
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

// Mock data for display
const mockReferrals = [
  {
    id: '1',
    name: 'John Doe',
    email: 'john.doe@example.com',
    status: 'completed',
    date: '2023-08-15',
  },
  {
    id: '2',
    name: 'Alice Smith',
    email: 'alice.smith@example.com',
    status: 'pending',
    date: '2023-08-14',
  },
  {
    id: '3',
    name: 'Bob Johnson',
    email: 'bob.johnson@example.com',
    status: 'approved',
    date: '2023-08-13',
  },
  {
    id: '4',
    name: 'Emma Wilson',
    email: 'emma.wilson@example.com',
    status: 'pending',
    date: '2023-08-12',
  },
];

const LatestReferralsPanel: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Latest Referrals</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {mockReferrals.map((referral) => (
            <div 
              key={referral.id}
              className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0"
            >
              <div>
                <div className="font-medium">{referral.name}</div>
                <div className="text-sm text-gray-500">{referral.email}</div>
              </div>
              <div className="flex flex-col items-end">
                <Badge 
                  className={
                    referral.status === 'completed' ? 'bg-green-100 text-green-800 hover:bg-green-200' :
                    referral.status === 'approved' ? 'bg-blue-100 text-blue-800 hover:bg-blue-200' :
                    'bg-yellow-100 text-yellow-800 hover:bg-yellow-200'
                  }
                >
                  {referral.status}
                </Badge>
                <div className="text-xs text-gray-500 mt-1">{referral.date}</div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default LatestReferralsPanel;
